import React, { useEffect, useRef, useState } from 'react';
import { LoadBIN, getImageSize, getRandomFloatInRange } from './Global.js';
import { Vector2, Vector3 } from './geometry.js';
import MobileOverlay from './MobileOverlay.js';
import SkillTitle from './SkillTitle.js';
import Hamburger from './Hamburger.js';

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

function Page1Mobile({ backgroundCanvasRef, aspectRatio, canvasResolution }) {
    const [headerClass, setHeaderClass] = useState("off");
    const [titleClass, setTitleClass] = useState("on");
    const [activeSkill, setActiveSkill] = useState(null);

    const currentIllustration = useRef("UN");
    const factIndex = useRef(0);
    const factOrder = useRef(Array.from({ length: 49 }, (_, i) => (i + 1).toString()));
    shuffleArray(factOrder.current);

    
    const skillCategories = {
        "Front End": ["React.js", "JavaScript", "TypeScript", "HTML/CSS", "Tailwind CSS", "Three.js"],
        "Back End": ["Node.js", "Python", "PHP", "Flask", "Django", "C#", ".NET", "REST APIs", "Kubernetes"],
        "Databases": ["MySQL", "MongoDB", "PostgreSQL"],
        "Technologies": ["Git/GitHub", "Docker", "Figma", "Azure", "AWS/Cloud Services"],
        "Other": ["Linux", "UI/UX", "CI/CD", "Agile/Scrum", "Selenium", "AI/LLMs"]
    };



    const illustrateFact = (tag, color = new Vector3(190, 190, 190)) => {
        tag = factOrder.current[factIndex.current];
        factIndex.current = (factIndex.current + 1) % factOrder.current.length;

        if (backgroundCanvasRef.current === null) return;
        currentIllustration.current = tag;

        LoadBIN(`json/lineart/${tag}.bin`, (data) => {
            let size = getImageSize(data);
            let mxHeight = Vector2.unit("80vh");
            let mxWidth = Vector2.unit("80vw");

            if (mxHeight <= mxWidth) size.scaleSize(null, mxHeight);
            else size.scaleSize(mxWidth, null);

            let pos = Vector2.sizeFromText("50w%", "50h%", backgroundCanvasRef.current);

            backgroundCanvasRef.current.drawPicture(
                data,
                pos,
                size,
                9999999,
                color,
                200,
                "frontIcon"
            );
        });
    };

    
        useEffect(() => {
            const handleScroll = () => {
                const header = document.querySelector(".header-holder");
                const title = document.querySelector(".title-wrapper");
                if (!header || !title) return;
        
                const headerRect = header.getBoundingClientRect();
                const titleRect = title.getBoundingClientRect();
        
                const headerCenterY = headerRect.top + headerRect.height / 2;
                const titleCenterY = titleRect.top + titleRect.height / 2;

                const isScrolledPast = titleCenterY < headerCenterY;
                
                // Only update state if the class actually changes
                if (isScrolledPast && headerClass !== "on") {
                    setHeaderClass("on");
                    setTitleClass("off");
                } else if (!isScrolledPast && headerClass !== "off") {
                    setHeaderClass("off");
                    setTitleClass("on");
                }
        
                // Adjust arrow opacity smoothly
                const scrollY = window.scrollY;
                const maxScroll = 100; // Adjust the value as needed
            };
        
            window.addEventListener('scroll', handleScroll);
            handleScroll(); // Run once to set initial state
        
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
    }, [headerClass]);

    
    const applySkill = (event, skill) => {
        if (skill === null){
            backgroundCanvasRef.current.disbandImage("frontIcon");
        }
        setActiveSkill(skill);
    };

    useEffect(() => {
        console.log("[Page1Mobile] prespawning level");
        // illustrateFact("");
        currentIllustration.current = "none";
        backgroundCanvasRef.current.prespawnLevel(
            Math.floor(getRandomFloatInRange(0, 3.99)), 
            "frontIcon",
            Vector2.sizeFromText("1vw", "1vh"),
            Vector2.sizeFromText("98vw", "98vh"),
        );

        SpawnHTMLGravity();
    }, [backgroundCanvasRef, canvasResolution]);

    const SpawnHTMLGravity = () => {
        const elementsWithCountered = document.querySelectorAll('[countered]');
        console.log(elementsWithCountered);
        elementsWithCountered.forEach(element => {
            if (backgroundCanvasRef.current) {
                backgroundCanvasRef.current.contourHTMLObject(element);
            }
        });
    };

    return (
        <div className="page1Mobile">
            <div className={`header-holder ${headerClass} on`}>
                <div className="header-left">
                    <h1 className="h1-title">Joe Sharipov</h1>
                    <h2 className="occupation-title">Software Engineer</h2>
                </div>
                <Hamburger></Hamburger>
            </div>
            <div id="title" className={`${titleClass}`}>
                <div className="title-wrapper" countered="1">
                    <h1 className="h1-title">Joe Sharipov</h1>
                    <h2 className="occupation-title">Software Engineer</h2>
                </div>
            </div>

            <MobileOverlay />



            <div className='section skill-section'>
                <SkillTitle activeSkill={activeSkill}></SkillTitle>
                <div className={`skills ${activeSkill ? "" : "active"}`}>
                    <div className={`skill`} onClick={(e) => {illustrateFact("technologies"); applySkill(e, "Technologies");}}>
                        <div className='skill-name'>
                            Technologies
                            <div className='skill-underline' />  
                        </div>
                    </div>
                    <div className={`skill`} onClick={(e) => {illustrateFact("lineart/1"); applySkill(e, "Front End");}}>
                        <div className='skill-name'>
                            Front End 
                            <div className='skill-underline' />  
                        </div>
                    </div>
                    <div className={`skill`} onClick={(e) => {illustrateFact("lineart/10"); applySkill(e, "Back End");}}>
                        <div className='skill-name'>
                            Back End
                            <div className='skill-underline' />  
                        </div>
                    </div>
                    <div className={`skill`} onClick={(e) => {illustrateFact("other"); applySkill(e, "Other");}}>
                        <div className='skill-name'>
                            Other
                            <div className='skill-underline' />  
                        </div>
                    </div>
                </div>

                <div className={`skill-details ${activeSkill ? "active" : ""}`}>
                    <div className='background-stripe'>
                        <ul>
                            {activeSkill && skillCategories[activeSkill].map((skill, index) => (
                                <li key={index}>{skill}</li>
                            ))}
                        </ul>
                    </div>
                    <div className='background-square' />
                    <h1 className='skill-details-title'>{activeSkill}</h1>
                    <img className='skill-back-button' src={`${process.env.PUBLIC_URL}/images/page1/ChevronLeft.png`} onClick={(e) => {applySkill(e, null);}}></img>
                </div>
            </div>
        </div>
    );
}

export default Page1Mobile;
